<main class="login-page" [class.embedded]="embedded" dir="rtl">
  <div class="login-shell">
    <div class="login-card">
      <div class="login-header">
        <div class="login-heading">
          <span *ngIf="!embedded" class="login-brand">راهداری GPS</span>
          <h1>{{ editId !== null ? 'ویرایش پیش‌ثبت‌نام' : 'ثبت‌نام خودرو' }}</h1>
          <p *ngIf="editId !== null && !isLoadingEdit" class="edit-status">وضعیت: <span>{{ installationStatus || '—' }}</span></p>
        </div>
        <a *ngIf="!embedded" class="close-button" routerLink="/specialist-verification" aria-label="بازگشت به بررسی اطلاعات خودرو">
          <mat-icon aria-hidden="true">close</mat-icon>
        </a>
        <button *ngIf="embedded" type="button" class="close-button" aria-label="بستن" (click)="closeEdit.emit()"><mat-icon aria-hidden="true">close</mat-icon></button>
      </div>

      <div class="login-body" [hidden]="isLoadingEdit">
        <p *ngIf="!embedded" class="form-intro">اطلاعات مالک و خودرو را وارد کنید.</p>
        <p *ngIf="editId !== null && !canEdit" class="edit-notice" role="status">امکان ویرایش این پیش‌ثبت‌نام وجود ندارد.</p>

        <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()">
          <h2 *ngIf="embedded" class="edit-section-title">اطلاعات مالک</h2>
          <!-- phoneNumber field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strMobile').value ? 'direction-ltr' : ''"
          >
            <label *ngIf="embedded" for="edit-mobile">شماره موبایل <span class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>phone_iphone</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              id="edit-mobile" formControlName="strMobile" aria-label="شماره موبایل"
              inputmode="numeric"
              appNumericOnly
              placeholder="* شماره موبایل"
            />
          </div>

          <!-- name field -->
          <div class="form-group has-icon">
            <label *ngIf="embedded" for="edit-name">نام <span class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              id="edit-name" formControlName="strName" aria-label="نام"
              placeholder="* نام"
            />
            <small *ngIf="invalidEditField('strName')" class="text-danger">نام را وارد کنید.</small>
          </div>

          <!-- family field -->
          <div class="form-group has-icon">
            <label *ngIf="embedded" for="edit-family">نام خانوادگی <span class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              id="edit-family" formControlName="strFamily" aria-label="نام خانوادگی"
              placeholder="* نام خانوادگی"
            />
            <small *ngIf="invalidEditField('strFamily')" class="text-danger">نام خانوادگی را وارد کنید.</small>
          </div>

          <!-- nationalId field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strID')?.value ? 'direction-ltr' : ''"
          >
            <label *ngIf="embedded" for="edit-id">کد ملی مالک <span class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>badge</mat-icon>
            </span>
            <input
              class="form-control"
              id="edit-id" formControlName="strID" aria-label="کد ملی مالک"
              inputmode="numeric"
              maxlength="11"
              appNumericOnly
              placeholder="* کد ملی مالک "
            />
            <small *ngIf="invalidEditField('strID')" class="text-danger">کد ملی معتبر ۱۰ رقمی وارد کنید.</small>
          </div>

          <!-- strTel field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strTel').value ? 'direction-ltr' : ''"
          >
            <label *ngIf="embedded" for="edit-tel">تلفن ثابت</label>
            <span class="form-control-icon">
              <mat-icon>fax</mat-icon>
            </span>
            <input
              class="form-control"
              id="edit-tel" formControlName="strTel" aria-label="تلفن ثابت"
              inputmode="numeric"
              maxlength="11"
              appNumericOnly
              placeholder="تلفن ثابت (اختیاری)"
            />
          </div>

          <!-- استان/شهر -->

          <div class="w-100 h-100">
            <div class="row gx-2 gy-0">
              <div class="col-6">
                <!-- state field -->
                <div class="form-group has-icon">
                  <label *ngIf="embedded" for="edit-state">استان</label>
                  <span class="form-control-icon">
                    <mat-icon>apartment</mat-icon>
                  </span>
                  <select id="edit-state" aria-label="استان" [value]="selectedState" [disabled]="editId !== null && !canEdit" (change)="getCities($event)">
                    <option [value]="null" disabled selected>* استان</option>
                    <option
                      *ngFor="let state of states$ | async"
                      [value]="state.strState"
                    >
                      {{ state.strStateName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-6">
                <!-- city field -->
                <div class="form-group has-icon">
                  <label *ngIf="embedded" for="edit-city">شهر <span class="required-mark" aria-hidden="true">*</span></label>
                  <span class="form-control-icon">
                    <mat-icon>apartment</mat-icon>
                  </span>
                  <select id="edit-city" formControlName="strCity" aria-label="شهر">
                    <option [value]="null" disabled selected>* شهر</option>
                    <option
                      *ngFor="let city of cities$ | async"
                      [value]="city.strCity"
                    >
                      {{ city.strCityName }}
                    </option>
                  </select>
                  <small *ngIf="invalidEditField('strCity')" class="text-danger">شهر را انتخاب کنید.</small>
                </div>
              </div>
            </div>
          </div>

          <!-- map picker field-->
          <div class="form-group has-icon map-field-wrapper">
            <label *ngIf="embedded" for="edit-address">آدرس <span *ngIf="showMap" class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>add_location_alt</mat-icon>
            </span>

            <input
              class="form-control"
              id="edit-address" formControlName="strAddress" aria-label="آدرس محل نصب"
              [placeholder]="
                showMap ? '* آدرس محل نصب' : 'آدرس محل نصب (اختیاری)'
              "
            />

            <button
              type="button"
              class="show-map-btn"
              aria-label="انتخاب آدرس روی نقشه"
              [disabled]="editId !== null && !canEdit"
              (click)="show_Map()"
            >
              <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            </button>

            <custom-map
              *ngIf="showMapDialog"
              [longLat]="[coordinates.fLon, coordinates.fLat]"
              [isOpenModal]="true"
              (mdl_Submit)="submitMap($event)"
            ></custom-map>
            <small *ngIf="invalidEditField('strAddress')" class="text-danger">آدرس را وارد کنید.</small>
          </div>

          <!-- carType field -->
          <h2 *ngIf="embedded" class="edit-section-title">مشخصات خودرو</h2>
          <div class="form-group has-icon">
            <label *ngIf="embedded" for="edit-group">گروه خودرو <span class="required-mark" aria-hidden="true">*</span></label>
            <span class="form-control-icon">
              <mat-icon>fire_truck</mat-icon>
            </span>
            <select id="edit-group" formControlName="tiMobileGroup" aria-label="گروه خودرو">
              <option [value]="null" disabled selected>* گروه خودرو</option>
              <option *ngFor="let carType of carTypes$ | async" [value]="carType.tiMobileGroup">
                {{ carType.strComment }}
              </option>
            </select>
            <small *ngIf="invalidEditField('tiMobileGroup')" class="text-danger">گروه خودرو را انتخاب کنید.</small>
          </div>

          <!-- سال تولید -->
            <div class="form-group has-icon">
              <label *ngIf="embedded" for="edit-year">سال تولید <span class="required-mark" aria-hidden="true">*</span></label>
              <span class="form-control-icon">
                <mat-icon class="mat-18">date_range</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                id="edit-year" formControlName="iYearConstruction" aria-label="سال تولید"
                [ngClass]="
                  formGroup.get('iYearConstruction').value
                    ? 'direction-ltr'
                    : ''
                "
                placeholder="* سال تولید"
                inputmode="numeric"
                maxlength="4"
                appNumericOnly
              />
              <small *ngIf="invalidEditField('iYearConstruction')" class="text-danger">سال تولید را وارد کنید.</small>
            </div>

            <!-- رنگ خودرو -->
            <div class="form-group has-icon">
              <label *ngIf="embedded" for="edit-color">رنگ خودرو</label>
              <span class="form-control-icon">
                <mat-icon class="mat-18">palette</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                id="edit-color" formControlName="strColor" aria-label="رنگ خودرو"
                placeholder="* رنگ خودرو"
              />
            </div>

            <!-- VIN -->
            <div class="form-group has-icon">
              <label *ngIf="embedded" for="edit-vin">VIN <span class="required-mark" aria-hidden="true">*</span></label>
              <span class="form-control-icon">
                <mat-icon class="mat-18">barcode_reader</mat-icon>
              </span>

              <input
                class="my-3 w-100 form-control"
                id="edit-vin" formControlName="strVIN" aria-label="شماره VIN"
                [ngClass]="formGroup.get('strVIN').value ? 'direction-ltr' : ''"
                placeholder="* VIN"
                maxlength="17"
              />
              <small class="text-danger" *ngIf="invalidEditField('strVIN') && formGroup.get('strVIN').hasError('required')">VIN را وارد کنید.</small>
              <small class="text-danger" *ngIf="formGroup.get('strVIN').hasError('minlength') && (formGroup.get('strVIN').dirty || formGroup.get('strVIN').touched)">VIN باید ۱۷ کاراکتر باشد.</small>
            </div>

          <!-- vehicleNumber field -->
          <div class="vehicle-no-field-wrapper">
            <span *ngIf="embedded" class="edit-field-label">پلاک <span class="required-mark" aria-hidden="true">*</span></span>
            <!-- <label for="strVehicleNo">پلاک خودرو</label> -->
            <div class="vehicle-no-field" id="strVehicleNo">
              <input
                type="text"
                maxlength="2"
                inputmode="numeric"
                class="border-left"
                formControlName="plak4" aria-label="پلاک، کد ایران"
                placeholder="- -"
                (keydown)="onlyNumber($event)"
              />
              <input
                type="text"
                maxlength="3"
                inputmode="numeric"
                formControlName="plak3" aria-label="پلاک، سه رقم"
                placeholder="- - -"
                (keydown)="onlyNumber($event)"
              />
              <input
                type="text"
                maxlength="1"
                formControlName="plak2" aria-label="پلاک، حرف"
                placeholder="-"
                (keydown)="onlyPersian($event)"
                (input)="sanitizePersian($event)"
              />
              <input
                type="text"
                maxlength="2"
                inputmode="numeric"
                formControlName="plak1" aria-label="پلاک، دو رقم"
                placeholder="- -"
                (keydown)="onlyNumber($event)"
              />
              <span><img alt="" src="./assets/imgs/iran-flag-dark.svg" /></span>
            </div>
            <small *ngIf="invalidEditField('plak1') || invalidEditField('plak2') || invalidEditField('plak3') || invalidEditField('plak4')" class="text-danger">پلاک خودرو را کامل و معتبر وارد کنید.</small>
          </div>

          <!-- تصویر مجوز صادره از طرف شرکت آب و فاضلاب  -->

          <div class="form-group position-relative mb-3">
              <p class="my-2">تصویر کارت خودرو (اختیاری)</p>
            <img *ngIf="editId !== null && formGroup.get('strLicenseImage').value as image"
              class="license-image" [src]="image.startsWith('data:image/') ? image : 'data:image/jpeg;base64,' + image"
              alt="تصویر کارت خودرو" />
            <file-uploader
              *ngIf="editId === null || canEdit"
              [maxFileSize]="3"
              (submit)="onFileSubmit($event)"
            ></file-uploader>
          </div>

          <!-- description field -->
          <div class="form-group has-icon edit-comment">
            <label *ngIf="embedded" for="edit-comment">توضیحات</label>
            <span class="form-control-icon">
              <mat-icon>description</mat-icon>
            </span>
            <textarea
              class="form-control"
              id="edit-comment" formControlName="strComment" aria-label="توضیحات"
              placeholder="توضیحات"
            ></textarea>
          </div>
          <div class="form-group has-icon payment-amount" [class.direction-ltr]="formGroup.get('iCost').value">
            <label for="payment-amount">مبلغ (ریال)</label>
            <span class="form-control-icon"><mat-icon aria-hidden="true">payments</mat-icon></span>
            <input id="payment-amount" type="text" class="form-control" formControlName="iCost" aria-label="مبلغ به ریال" placeholder="مبلغ (ریال)" inputmode="numeric" (input)="onAmountInput($event)" aria-describedby="payment-amount-error" />
            <small id="payment-amount-error" class="text-danger" *ngIf="formGroup.get('iCost').invalid">مبلغ واردشده معتبر نیست.</small>
          </div>
          <ng-container *ngIf="editId !== null">
            <div class="form-group edit-device-field">
              <label for="edit-imei">IMEI</label>
              <input id="edit-imei" class="form-control" formControlName="strIMEI" inputmode="numeric" appNumericOnly maxlength="15" dir="ltr" placeholder="IMEI دستگاه" />
            </div>
            <div class="form-group edit-device-field">
              <label for="edit-cell">شماره سیم‌کارت</label>
              <input id="edit-cell" class="form-control" formControlName="strCellNo" inputmode="numeric" appNumericOnly maxlength="11" dir="ltr" placeholder="شماره سیم‌کارت دستگاه" />
            </div>
            <div class="form-group edit-payment-comment">
              <label for="edit-payment-comment">توضیحات پرداخت</label>
              <textarea id="edit-payment-comment" class="form-control" formControlName="strPaymentComment" placeholder="توضیحات پرداخت"></textarea>
            </div>
            <div class="form-group edit-signature">
              <span class="edit-field-label">امضای تحویل‌گیرنده</span>
              <app-signature-field [value]="formGroup.get('strSignatureImage').value || ''" [disabled]="!canEdit" (valueChange)="onSignatureChanged($event)"></app-signature-field>
            </div>
          </ng-container>
        </form>
      </div>

      <div class="login-body" *ngIf="isLoadingEdit" role="status">در حال دریافت اطلاعات...</div>
      <div class="login-footer" [hidden]="isLoadingEdit || (editId !== null && !canEdit)">
        <button
          type="button"
          class="submit-button"
          [disabled]="
            isSubmitDisabled || (editId === null && (formGroup.invalid || formGroup.pristine))
          "
          (click)="form.ngSubmit.emit()"
        >
          {{ editId !== null ? 'ذخیره تغییرات' : 'ثبت نام' }}
        </button>
      </div>
    </div>
  </div>
</main>
